import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FiHome, 
  FiCalendar, 
  FiAward, 
  FiUsers, 
  FiMaximize, 
  FiPercent, 
  FiUserCheck, 
  FiSettings, 
  FiPlus, 
  FiLogOut,
  FiDollarSign
} from 'react-icons/fi';
import AuthService from '../services/AuthService';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const user = AuthService.getCurrentUser() || { name: { first: 'Organizer', last: 'User' }, email: 'picvot.contact@gmail.com' };
  const displayName = typeof user.name === 'object' ? `${user.name?.first || ''} ${user.name?.last || ''}`.trim() : (user.name || 'Organizer Account');

  const menuItems = [
    { name: 'Dashboard', path: '/app', icon: FiHome },
    { name: 'Events (IRL & Online)', path: '/app/events', icon: FiCalendar },
    { name: 'Contests & Challenges', path: '/app/contests', icon: FiAward },
    { name: 'Attendees & Tickets', path: '/app/attendees', icon: FiUsers },
    { name: 'Earnings & Payouts', path: '/app/payouts', icon: FiDollarSign },
    { name: 'Event Staff Access', path: '/app/staff', icon: FiUserCheck },
    { name: 'Promo & Coupons', path: '/app/promocodes', icon: FiPercent },
    { name: 'Settings', path: '/app/settings', icon: FiSettings },
  ];

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-40 w-64 bg-white border-r border-slate-200 transition-all duration-300 transform md:translate-x-0 md:static flex flex-col justify-between ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <div className="p-5">
        {/* Brand Logo */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-purple-700 flex items-center justify-center text-white font-black text-lg shadow-sm">
              T
            </div>
            <div>
              <span className="text-lg font-black tracking-wider text-slate-900">TAPCOE</span>
              <span className="block text-[10px] text-purple-700 font-bold uppercase tracking-widest">Partner Panel</span>
            </div>
          </div>
        </div>

        {/* Action Button: Create Event */}
        <Link
          to="/app/create"
          className="w-full py-3 px-4 rounded-xl font-bold text-xs text-white bg-purple-700 hover:bg-purple-800 transition-all shadow-sm flex items-center justify-center gap-2 mb-6"
        >
          <FiPlus className="w-4 h-4" />
          <span>+ Create Event</span>
        </Link>

        {/* Navigation Menu List */}
        <nav className="space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || (item.path !== '/app' && location.pathname.startsWith(item.path));

            return (
              <Link
                key={item.name}
                to={item.path}
                className={`flex items-center justify-between px-3.5 py-2.5 rounded-xl text-xs font-semibold transition-all ${
                  isActive
                    ? 'bg-purple-50 text-purple-800 border border-purple-200 font-bold'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
                }`}
              >
                <div className="flex items-center gap-3">
                  <Icon className={`w-4 h-4 ${isActive ? 'text-purple-700' : 'text-slate-400'}`} />
                  <span>{item.name}</span>
                </div>
                {item.badge && (
                  <span className={`text-[9px] px-2 py-0.5 rounded-full font-bold uppercase ${
                    item.badge === 'Main' ? 'bg-emerald-100 text-emerald-800 border border-emerald-200' : 'bg-purple-100 text-purple-800 border border-purple-200'
                  }`}>
                    {item.badge}
                  </span>
                )}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Organizer User Footer Card */}
      <div className="p-4 border-t border-slate-200 bg-slate-50">
        <div className="p-3 rounded-xl bg-white border border-slate-200 flex items-center justify-between shadow-sm">
          <div className="flex items-center gap-3 overflow-hidden">
            <div className="w-8 h-8 rounded-lg bg-purple-100 border border-purple-200 flex items-center justify-center text-purple-800 font-bold text-xs shrink-0">
              {displayName.charAt(0)}
            </div>
            <div className="overflow-hidden text-left">
              <span className="text-xs font-bold text-slate-900 block truncate">{displayName}</span>
              <span className="text-[10px] text-slate-500 block truncate">Organizer Account</span>
            </div>
          </div>
          <button
            onClick={() => AuthService.logout()}
            className="text-slate-400 hover:text-red-600 p-1.5 transition-colors"
            title="Logout"
          >
            <FiLogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
